const axios = require('axios');

class AjaxService {
  constructor (rootStore, onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse) {
    this.rootStore = rootStore
    this.onRequestConfig = onRequestConfig && (typeof onRequestConfig === 'function') ? onRequestConfig : () => { }
    this.onRequestConfigError = onRequestConfigError && (typeof onRequestConfigError === 'function') ? onRequestConfigError : () => { }
    this.onResponse = onRequestConfig && (typeof onResponse === 'function') ? onResponse : () => { }
    this.onResponseError = onResponseError && (typeof onResponseError === 'function') ? onResponseError : () => { }
    this.onNoServerResponse = onNoServerResponse && (typeof onNoServerResponse === 'function') ? onNoServerResponse : () => { }
  }

  doAjax (method, path, data) {
    let basePath = process.env.PORTALE_PATH
    let apiPath = ""
    let uri = ''
    console.log("path origin: " + path)

    if (process.env.API === 'locale') {
      basePath = '';
      path = path.replace("/sign-oss", "");
      uri = `http://127.0.0.1:3000${ basePath }${ apiPath }${ path }`
    } else {

      uri = `${ basePath }${ apiPath }${ path }`
    }

    $.support.cors = true;
    console.log("uri path: " + uri)
    let config = {
      method: method,
      url: uri,
      data: data ? JSON.stringify(data) : null,
      headers: {
        "Content-Type": "application/json"
      }
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {
      console.debug(`request ${ uri } - config ${ JSON.stringify(response) }`)
      this.onResponse.call(this, response)
      return {
        success: true,
        result: response.data
      }
    })
      .catch(error => {
        if (error.response) {
          this.onResponseError.call(this, error)
          return {
            success: false,
            result: error.response.data
          }
        } else if (error.request) {
          this.onNoServerResponse.call(this, error)
          console.debug(`no response received ${ uri } - error ${ JSON.stringify(error.request) }`)
        } else {
          this.onRequestConfigError.call(this, error)
          console.debug(`request config error ${ uri } - error ${ JSON.stringify(error.message) }`)
        }
        console.debug(`request ${ uri } - config ${ JSON.stringify(error.config) }`)
      });

  }

  doAjaxPDF (method, path, data) {
    let basePath = process.env.PORTALE_PATH
    let apiPath = ""
    let uri = ''
    console.log("path origin: " + path)

    if (process.env.API === 'locale') {
      basePath = '';
      path = path.replace("/sign-oss", "");
      uri = `http://127.0.0.1:3000${ basePath }${ apiPath }${ path }`
    } else {

      uri = `${ basePath }${ apiPath }${ path }`
    }

    $.support.cors = true;
    console.log("uri path: " + uri)
    let config = {
      method: method,
      url: uri,
      data: data ? data : null,
      headers: {
        'content-type': 'application/json',
        'charset': 'utf-8'
        /* "Accept": "application/json" */
      },
      responseType: 'blob'
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {
      console.debug(`request ${ uri } - config ${ JSON.stringify(response) }`)
      this.onResponse.call(this, response)
      return {
        success: true,
        result: response.data
      }
    })
      .catch(error => {
        if (error.response) {
          this.onResponseError.call(this, error)
          return {
            success: false,
            result: error.response.data
          }
        } else if (error.request) {
          this.onNoServerResponse.call(this, error)
          console.debug(`no response received ${ uri } - error ${ JSON.stringify(error.request) }`)
        } else {
          this.onRequestConfigError.call(this, error)
          console.debug(`request config error ${ uri } - error ${ JSON.stringify(error.message) }`)
        }
        console.debug(`request ${ uri } - config ${ JSON.stringify(error.config) }`)
      });

  }

  doAjaxCaptcha (method, path) {
    let apiPath = ""
    let uri = ''
    let basePath = '/Api-OssRegRichIdServizi'
    uri = `${ basePath }${ apiPath }${ path }`
    console.log("path origin: " + path)


    $.support.cors = true;
    console.log("uri path: " + uri)
    let config = {
      method: method,
      url: uri,
      data: '',
      headers: {
        "Content-Type": "application/json"
      }
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {
      console.debug(`request ${ uri } - config ${ JSON.stringify(response) }`)
      this.onResponse.call(this, response)
      return { success: true, result: response.data, url: response.request.responseURL }
    })
      .catch(error => {
        if (error.response) {
          this.onResponseError.call(this, error)
          return { success: false, result: error.response.data, url: error.response.request.responseURL }
        } else if (error.request) {
          this.onNoServerResponse.call(this, error)
          console.debug(`no response received ${ uri } - error ${ JSON.stringify(error.request) }`)
        } else {
          this.onRequestConfigError.call(this, error)
          console.debug(`request config error ${ uri } - error ${ JSON.stringify(error.message) }`)
        }
        console.debug(`request ${ uri } - config ${ JSON.stringify(error.config) }`)
      });
  }

}

export default AjaxService;